/**
 * PCI DSS 6.4.3 Compliance utilities for script loading
 * These utilities ensure that only authorized scripts are loaded
 * and provide logging for compliance monitoring
 */

// PCI DSS 6.4.3 Compliance: Allowed third-party script sources
// These are the only external scripts authorized for loading by the SDK
export const ALLOWED_SCRIPT_PREFIXES = [
  // Primer SDK CDN (including dynamically generated chunks)
  'https://sdk.primer.io/web/',
  'https://sdk.dev.primer.io/web/',
  'https://sdk.sandbox.primer.io/web/',
  'https://sdk.production.primer.io/web/',
  // Legacy Primer assets URL
  'https://assets.primer.io/',
  // Local development URLs (only in development/test)
  ...(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
    ? ['//localhost:', 'http://localhost:', 'https://localhost:']
    : []),
  // Klarna SDK
  'https://x.klarnacdn.net/kp/lib/v',
  // PayPal SDK
  'https://www.paypal.com/sdk/js',
  'https://www.paypalobjects.com/',
  // Stripe SDK (for ACH payments)
  'https://js.stripe.com/',
  // Google Pay
  'https://pay.google.com/gp/p/js/',
];

/**
 * Validates that a script source is in the allowed list
 * Required for PCI DSS 6.4.3 compliance
 * @param source - The script URL to validate
 * @returns true if the script is allowed, false otherwise
 */
export function isScriptAllowed(source: string): boolean {
  return ALLOWED_SCRIPT_PREFIXES.some((prefix) => source.startsWith(prefix));
}
